// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const ThreeSceneContract = contract({
  name: "ThreeScene",
  description: "WebGL primitive for shader backgrounds, generative visuals, and bespoke three.js scenes. Three authoring paths, in order of preference — (1) pick a `preset` id; (2) if nothing in the registry fits, write a `fragmentShader` against the fixed uniform contract; (3) only as a last resort, pass a full `createScene` factory. For looping video, use VideoPlayer; for interactive animations, use RivePlayer.",
  import: "@gradeui/ui",
  aliases: ["three","threejs","webgl","shader","scene","3d","generative","hero background","fragment shader","glsl"],
  composesWith: ["MediaSurface (internal)","foreground content stacked above with `position: absolute/relative z-10`"],
  styleDefaults: {"ThreeScene":"absolute inset-0 flex items-end justify-end p-2"},
  props: {
  "preset": {
      schema: z.enum(["mesh", "waves", "space", "plasma", "voronoi", "synthwave"]).optional(),
      design: "knob",
      description: "shader preset id from the registry",
  },
  "fragmentShader": {
      schema: z.string().optional(),
      design: "content",
      description: "user-authored GLSL body; takes precedence over preset",
  },
  "onShaderError": {
      schema: z.unknown().optional(),
      design: "event",
      description: "fires on compile failure; scene falls back to `preset=\"space\"`",
  },
  "postPreset": {
      schema: z.enum(["none", "vhs", "cinematic", "synthwave", "crt"]).optional(),
      design: "knob",
      description: "post-processing pass",
      default: "vhs",
  },
  "palette": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "any CSS-legal colour string per slot. Re-tints automatically when the theme changes. Unset slots fall back to defaults.",
  },
  "createScene": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "custom full scene factory; takes precedence over preset AND fragmentShader",
  },
  "controls": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "play/pause overlay",
      default: false,
  },
  "autoPlay": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "respects reduced-motion",
      default: true,
  },
  "pauseOffscreen": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "big win for WebGL battery life",
      default: true,
  },
  "aspect": {
      schema: z.enum(["video", "square", "portrait", "wide", "auto"]).optional(),
      design: "knob",
      default: "video",
  },
  "maxDpr": {
      schema: z.number().optional(),
      design: "knob",
      description: "lower for thumbnails / low-end devices",
  },
  "radius": {
      schema: z.enum(["none", "sm", "md", "lg", "xl"]).optional(),
      design: "knob",
      default: "lg",
  },
  },
});
